import { io } from "socket.io-client";
import { getAccessToken } from "./auth";

const socket = io(WS_ENDPOINT, {
  autoConnect: false,
  auth: (cb) => {
    const token = getAccessToken()
      // console.log('getacces',token);
    cb({ token });
  }
});

socket.on("connect_error", (err) => {
  console.log(`connect_error due to ${err.message}`);
});

export default socket;
